import(/* webpackMode: "eager", webpackExports: ["Form"] */ "/home/circleci/project/src/features/advices/components/Search/Form.tsx");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/src/modules/landingSearch/components/Headline/Headline.module.css");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/src/modules/layouts/components/Layout/Layout.module.css");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/src/features/advices/components/WithCommonHeaderPageLayout/WithCommonHeaderPageLayout.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["Tabs"] */ "/home/circleci/project/src/modules/layouts/components/Tabs/Tabs.tsx");
